const config = {
    development: {
        url: 'https://f1-staging-mcvn.merchize.com/api',
        barcodeUrl: 'https://f1-staging-mcvn.merchize.com/api/order',
    },
    production: {
        url: process.env.REACT_APP_HOST_API || 'https://next-service.merchize.com',
        barcodeUrl: process.env.REACT_APP_HOST_API_ORDER || 'https://next-service.merchize.com',
    },
    test: {
        url: 'https://next-service.merchize.com',
        barcodeUrl: 'https://next-service.merchize.com'
    }
};

const nodeEnv = !!process.env.REACT_APP_ENVIRONMENT ? process.env.REACT_APP_ENVIRONMENT : 'development';
export default config[nodeEnv];
